import React from 'react';
import { Button } from '../ui/Button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/oYpYxSszLsXsm35KitQu5w/heylloyd-image-1770260700217.png';
export function Hero() {
  return <section className="relative w-full bg-[#FDFCF8] pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-113">
        <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-stone-600 uppercase bg-stone-100 rounded-full" data-id="element-114">
          Para hijos/as cuidadores
        </span>
        <h1 className="text-4xl md:text-6xl font-bold text-stone-900 leading-tight mb-6" data-id="element-115">
          Si mañana no estás, <br className="hidden md:block" data-id="element-116" />
          <span className="italic text-stone-600" data-id="element-117">¿quién sabe qué hacer?</span>
        </h1>
        <p className="text-xl md:text-2xl text-stone-600 italic mb-8" data-id="element-118">
          "Si yo no lo sostengo, se cae todo."
        </p>
      </div>

      <div className="max-w-sm mx-auto mb-16" data-id="element-119">
        <img src={PRODUCT_IMAGE} alt="Cuidador Sin Caos - Kit imprimible para organizar medicamentos, turnos y emergencias" className="w-full h-auto drop-shadow-2xl" data-id="element-120" />
      </div>

      <div className="max-w-2xl mx-auto prose prose-stone prose-lg" data-id="element-121">
        <p className="text-xl font-medium text-stone-800 mb-6" data-id="element-122">
          Hay un tipo de cansancio que no se arregla durmiendo.
        </p>
        <p className="text-stone-600 mb-4" data-id="element-123">
          Es el cansancio de ser la persona que{' '}
          <strong data-id="element-124">se acuerda de todo</strong>: qué toma, a qué hora, qué cambió,
          cuándo es el turno, dónde quedó la receta, quién puede ir, qué hay que
          llevar, qué hay que preguntar, qué hay que firmar, qué hay que pagar,
          a quién hay que llamar.
        </p>
        <p className="text-stone-600 mb-4" data-id="element-125">
          Y encima… que parezca que "no es tanto".
        </p>
        <p className="text-stone-600 mb-8" data-id="element-126">
          Hasta que un día se te escapa algo mínimo. Y te queda esa sensación
          horrible en el pecho:
        </p>
        <div className="bg-white p-6 md:p-8 rounded-xl border border-stone-200 shadow-sm text-center" data-id="element-127">
          <p className="text-xl md:text-2xl font-serif font-medium text-stone-800" data-id="element-128">
            "Si yo no lo sostengo, se cae todo."
          </p>
        </div>
      </div>
    </section>;
}